/*jslint browser: true */
/*global window */

window._lec = window._lec || [];

(function() {
    'use strict';

    var pageTracker = require('./tracker.js');
    window.console.log(pageTracker);
    pageTracker.pushAll(window._lec);

    window._lec = pageTracker;
})();
